<template>
  <div class="groupList">
    <div class="header">
      <header class="head_panel detail">
        <div class="title_header">
          <div class="menu_icon" @click="callbackFunction()">
            <i class="material-icons">keyboard_backspace</i>
          </div>
        </div>
        <h3 class="detail_head_text">{{$t('groupOnProduct')}}</h3>
        <div
          class="create_group"
          @click="openGroupterms = !openGroupterms"
          :class="{'visibilityHidden' : isGroupCreated}"
        >
          <i class="material-icons">group_add</i>
          <span>{{$t('createGroup')}}</span>
        </div>
      </header>
    </div>
    <section class="detail_content gryBack">
      <CreatedProductGroup :groupValue="existGroup" />
      <GroupTerms v-if="openGroupterms" @closeGroupTerms="closeGroupterms" :minOrderData="minOrderId"  />
      <infinite-loading @infinite="existingGroup" spinner="circles">
        <template slot="no-more">no more results</template>
      </infinite-loading>
    </section>
    <div class="loader" v-if="loading">
      <img src="../../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import CreatedProductGroup from "../ProductDetailTab/CreatedProductGroup";
import GroupTerms from "../ProductDetailTab/GroupTerms";
export default {
  name: "GroupList",
  components: {
    CreatedProductGroup,
    GroupTerms
  },
  data() {
    return {
      details: {},
      openGroupterms: false,
      existGroup: [],
      groupIndex: 0,
      isGroupCreated: false,
      minOrderId: '',
      loading: false
    };
  },
  methods: {
    callbackFunction() {
      this.$router.go(-1);
    },
    closeGroupterms(value) {
      this.openGroupterms = value;
    },

    // to get group listing need productId and itemId is for Create shopping group
    existingGroup($state) {
      const obj = {
        productId: this.$route.query.productId,
        pageIndex: this.groupIndex
      };
      this.$store
        .dispatch({
          type: "getGroup",
          payload: obj
        })
        .then(data => {
          this.loading = false
          if (data.data.groupSocialInfoDTO.length) {
            if (this.groupIndex == 0) {
              this.isGroupCreated = data.data.isGroupCreatedByUser;
              this.minOrderId = data.data.groupSocialInfoDTO[0].minOrdersToFormNewGroup;
            }
            this.groupIndex += 1;
            this.existGroup.push(...data.data.groupSocialInfoDTO);
            this.$store.commit("saveGroupData", {
              groupListData: this.existGroup,
              groupIndex: this.groupIndex + 1
            });
            $state && $state.loaded();
          } else {
            $state && $state.complete();
          }
        })
        .catch(err => {
          console.log(err)
        });
    }
  },
   mounted(){
    this.loading = true
  }
};
</script>
